import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M11 17v4', key: '14wq8k' }],
  ['path', { d: 'M14 3v8a2 2 0 0 0 2 2h5.865', key: '12oo5h' }],
  ['path', { d: 'M17 17v4', key: 'hdt4hh' }],
  [
    'path',
    { d: 'M18 17a4 4 0 0 0 4-4 8 6 0 0 0-8-6 6 5 0 0 0-6 5v3a2 2 0 0 0 2 2z', key: 'yynif' },
  ],
  ['path', { d: 'M2 10v5', key: 'sa5akn' }],
  ['path', { d: 'M6 3h16', key: '27qw71' }],
  ['path', { d: 'M7 21h14', key: '1ugz0u' }],
  ['path', { d: 'M8 13H2', key: '1thz1o' }],
];

/**
 * @component @name Helicopter
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMTd2NCIgLz4KICA8cGF0aCBkPSJNMTQgM3Y4YTIgMiAwIDAgMCAyIDJoNS44NjUiIC8+CiAgPHBhdGggZD0iTTE3IDE3djQiIC8+CiAgPHBhdGggZD0iTTE4IDE3YTQgNCAwIDAgMCA0LTQgOCA2IDAgMCAwLTgtNiA2IDUgMCAwIDAtNiA1djNhMiAyIDAgMCAwIDIgMnoiIC8+CiAgPHBhdGggZD0iTTIgMTB2NSIgLz4KICA8cGF0aCBkPSJNNiAzaDE2IiAvPgogIDxwYXRoIGQ9Ik03IDIxaDE0IiAvPgogIDxwYXRoIGQ9Ik04IDEzSDIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/helicopter
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const Helicopter = createLucideIcon('helicopter', __iconNode);

export default Helicopter;
